<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Varian" subTitle="Forms" />

    <CreateVarian />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateVarian from "@/components/Pages/Management/Varian/CreateVarian.vue";

export default defineComponent({
  name: "CreateVarianPage",
  components: {
    PageTitle,
    CreateVarian,
  },
});
</script>
